import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { ToastProvider } from "@/shared/contexts/ToastContext";

export default function AuthLayout() {
  return (
    <ToastProvider>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />
        <main className="flex-1 w-full pb-16">
          <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="p-4 sm:p-6 lg:p-8 mt-16 space-y-6 h-fit bg-gray-50">
              <Outlet />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}
